module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_PDF-Icon_red-013ff84966bb825403d1a72d3bde5246.svg";